import { useListNotesQuery } from "@generated";
import { RootState } from "@reducers/rootReducer";
import { useSelector } from "react-redux";
import { Note } from "../types/Note";

interface UseListNotesArgs {
  projectId: number;
  page?: { number?: number; size?: number };
}

const useListNotes = ({ projectId, page }: UseListNotesArgs) => {
  const { accountSlug } = useSelector((state: RootState) => state.slug);

  const { data, error, isLoading, isFetching, refetch } = useListNotesQuery({
    slug: accountSlug,
    projectId,
    page,
  });

  const notes: Note[] =
    data?.data?.map((note: any) => ({
      id: String(note.id),
      name: note.attributes?.name || "",
      content: note.attributes?.content || "",
      username: note.attributes?.username || "",
      createdAt: note.attributes?.created_at || "",
      editable: note.attributes?.editable ?? false,
    })) || [];

  const pageMeta = {
    pageCount: data?.meta?.["page-count"] || 1,
    recordCount: data?.meta?.["record-count"] || 0,
  };

  return {
    notes,
    notesError: error,
    notesLoading: isLoading,
    notesFetching: isFetching,
    pageMeta,
    refetch,
  };
};

export default useListNotes;
